import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import HoverOverlay from "../general/HoverOverlay";
function CellTooltip(props) {
    const { value, contents } = props;
    return (_jsx(HoverOverlay, { ...props, contents: contents, children: _jsx("div", { className: "tooltip-wrapper", children: value }) }));
}
export default CellTooltip;
